/* How the queue object comes from connect.Contact.getQueue();
name:"NeonR1Q1"
queueARN: "arn:aws:connect:ap-southeast-2:788373746345:instance/03d40c94-890b-4a93-8afc-9f0e777bda49/queue/a6ab9ea1-bb23-4e2e-a2cf-8df9467d483b"
queueId:"arn:aws:connect:ap-southeast-2:788373746345:instance/03d40c94-890b-4a93-8afc-9f0e777bda49/queue/a6ab9ea1-bb23-4e2e-a2cf-8df9467d483b"
*/

export default function getQueueIdFromArn(queueArn?: string): string | undefined {
  return queueArn?.split('/queue/').pop();
}
